import React from 'react';

export const ConfigContext = React.createContext();
ConfigContext.displayName = 'ConfigContext';
